import React from 'react';
import { Platform, StyleSheet, View, ViewStyle } from 'react-native';

export interface TableHeadProps {
  children: React.ReactNode;
}

export const TableHead: React.FC<TableHeadProps> = ({ children }) => {
  return (
    <View role="rowgroup" style={styles.pinned}>
      {children}
    </View>
  );
};

const styles = StyleSheet.create({
  pinned: {
    ...Platform.select({
      // Sticky is a valid web style but not included in RN types
      web: { position: 'sticky' as ViewStyle['position'] },
    }),
    top: 0,
    zIndex: 1,
  },
});
